export default __webpack_public_path__ + "static/marketing-bb96ccd9c75c149cd3e025e5651ce5c4.svg";